import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  iconRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'transparent'
  },

  icon: {
    marginRight: '0.3125rem',
    border: '0.0625rem solid',
    borderRadius: '50%',
    boxSizing: 'border-box',
    padding: '0.125rem',
    backgroundColor: 'transparent',
    fontSize: theme.size.xl
  },

  start: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    fontSize: theme.size.sm,
    justifyContent: 'center'
  }
}))

export default useStyles
